module.exports = __webpack_public_path__ + "8632daebc3c496f56f1ac3c3eb6df2dc.svg";